// src/app/manufacturer-add/manufacturer-add.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ManufacturerService } from '../Services/manufacture.service';
import { Manufacturer } from "../objects/Manufacturer";


@Component({
  selector: 'app-manufacturer-add',
  templateUrl: './manufacturer-add.component.html',
  styleUrls: ['./manufacturer-add.component.css'],
})
export class ManufacturerAddComponent implements OnInit {
  newManufacturer: Manufacturer = {
    id: 0,
    name: '',
    country: '',
  };

  constructor(private router: Router, private manufacturerService: ManufacturerService) {}

  ngOnInit() {}

  saveManufacturer() {
    this.manufacturerService.addManufacturer(this.newManufacturer).subscribe((result) => {
      console.log('New manufacturer added successfully!');
      this.router.navigate(['/manufacturers']);
    });
  }
}
